export default {
    description: "Description",
    orderingNote: "Ordering Note"
}